import { useContext } from "react";
import PageMenuItem from "../../../../../Layout/PageMenu/PageMenuItem";
import { EditProjectContext } from "../../../EditProjectContext";
import { getLtlPipeline } from "../GetLtlPipeline";
import { ProjectState } from "../../../../ViewModel/ProjectState";

type Props = {
  readonly onClick?: () => void;
  disabled?: boolean;
};

export const AddButton = ({ onClick, disabled }: Props) => {
  const editProjectContext = useContext(EditProjectContext);
  const { project } = editProjectContext;

  function isButtonDisabled(): boolean {
    const ltlPipeline = getLtlPipeline(editProjectContext);
    const isFinished = ltlPipeline?.IsFinished || false;

    return project.State !== ProjectState.Sandbox || isFinished;
  }

  return (
    <PageMenuItem
      onClick={onClick}
      align="left"
      color="primary"
      type="button"
      disabled={disabled || isButtonDisabled()}
    >
      Add
    </PageMenuItem>
  );
};
